import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { processSession } from '../../lib/api';
import { useAuthStore } from '../../lib/authStore';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const { setUser } = useAuthStore();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    const process = async () => {
      try {
        const resp = await processSession(sessionId);
        setUser(resp.data);
        navigate('/', { replace: true, state: { user: resp.data } });
      } catch (err) {
        console.error('Auth error:', err);
        navigate('/login', { replace: true });
      }
    };
    process();
  }, [location, navigate, setUser]);

  return null;
}
